<template>
  <div>
    <hr class="border border-black-light-2 my-6" />
    <div @click="onClick" class="flex items-center justify-between px-2">
      <h2 class="font-medium fs-24">Activities</h2>
      <svg width="24" height="24">
        <use xlink:href="/img/sprite.svg#ic_chevron-right--solid"></use>
      </svg>
    </div>

    <zb-modal
      ref="activitiesDetailModal"
      class="slide-in-modal"
      :no-padding="true"
    >
      <template v-slot:title>
        <h2 class="fs-20 font-medium p-6">Activities</h2>
      </template>

      <template v-slot:default>
        <hr class="border border-black-light-2 mb-6" />
        <div class="px-4">
          <p class="mb-3 text-black">
            Our travel experts can arrange scuba diving and other activities as
            part of your reservation. Prices are subject to change.
          </p>

          <div
            v-for="(group, index) in groupedActivities"
            :key="index"
            class="activity-panel__container active overflow-hidden border border-black-30 activity-group rounded-lg"
            :class="group[0].category"
            :data-activity-id="index"
          >
            <div
              class="activity-panel__title cursor-pointer activity-group-header px-6 py-4 bg-black-light-1 flex justify-between items-center"
              v-if="group[0].category !== 'note'"
            >
              <h3 class="fs-20">
                {{ group[0].category | categoryName }}
              </h3>
            </div>

            <div class="activity-panel__content">
              <div
                v-for="activity in group"
                :key="activity.id"
                class="px-6 py-4 activity-item"
              >
                <div :class="{ italic: activity.category === 'note' }">
                  <span v-if="activity.category === 'note'">*</span>
                  {{ activity.activity_name }}
                </div>

                <div v-if="activity.category !== 'note'">
                  <currency-context>
                    <template v-slot="{ convert }">
                      <span v-text="convert(activity.activity_price)"></span>
                    </template>
                  </currency-context>
                  {{ activity.activity_price_metric | priceMetric }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </zb-modal>
  </div>
</template>

<script>
import orderBy from "lodash/orderBy";
import { DIVE_CENTER_FACILITIES } from "../../helpers/constants";
import takeWhile from "lodash/takeWhile";
import dropWhile from "lodash/dropWhile";
import CurrencyContext from "./CurrencyContext";

export default {
  props: ["resortId"],
  components: {
    CurrencyContext,
  },
  props: ["resortId"],
  data() {
    return {
      supplierActivities: [],
    };
  },
  filters: {
    categoryName(categoryValue) {
      switch (categoryValue) {
        case "dive":
          return "Certified divers";
        case "course":
          return "Diving courses";
        case "tour":
          return "Tours";
      }
    },
    priceMetric(priceMetric) {
      switch (priceMetric) {
        case "per_person":
          return "/person";
        case "per_day":
          return "/day";
        case "per_dive":
          return "/dive";
        case "per_week":
          return "/week";
        case "per_trip":
          return "/trip";
      }
    },
  },
  computed: {
    groupedActivities() {
      const groups = [];
      let activities = [...this.supplierActivities];

      while (activities.length) {
        let category = activities[0].category;
        const subgroup = takeWhile(
          activities,
          (act) => act.category === category
        );
        activities = dropWhile(activities, (act) => act.category === category);

        groups.push(subgroup);
      }

      const result = [];

      groups.forEach((group) => {
        if (group[0].category !== "note") {
          result.push(group);
        } else {
          result[result.length - 1] = result[result.length - 1].concat(group);
        }
      });

      return result;
    },
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((response) => {
      this.supplierActivities = response.supplier_activities || [];

      this.$nextTick(() => {
        window.initStickyNav();
      });
    });
  },
  methods: {
    onClick() {
      this.$refs.activitiesDetailModal.show();

      this.$el.querySelector(".zb-modal-scrollable-content").scrollTop = 0;
    },
  },
};
</script>

<style scoped>
.activity-item {
  display: grid;
  grid-template-columns: auto max-content;
  border-bottom: 1px solid var(--border-primary);
  gap: 1rem;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-group-header {
  border-bottom: unset;
}

.activity-panel__container.active .activity-group-header {
  border-bottom: 1px solid var(--border-primary);
}

.activity-group {
  margin-bottom: 20px;
}

.activity-group.note {
  margin-top: -40px;
  border-top: 0;
}

.activity-group.dive + .activity-group.note + .activity-group.dive,
.activity-group.tour + .activity-group.note + .activity-group.tour,
.activity-group.course + .activity-group.note + .activity-group.course {
  margin-top: -20px;
}

.activity-group.dive
  + .activity-group.note
  + .activity-group.dive
  .activity-group-header,
.activity-group.tour
  + .activity-group.note
  + .activity-group.tour
  .activity-group-header,
.activity-group.course
  + .activity-group.note
  + .activity-group.course
  .activity-group-header {
  display: none;
}

.activity-panel__title,
.icon,
.icon svg {
  transition: 0.3s;
}

.activity-panel__content p:last-of-type {
  margin-bottom: 0;
}

.faq__main-container hr {
  color: #e0e0e0;
}

.activity-panel__container.active .icon {
  transform: rotateZ(90deg);
}

.activity-panel__container.active {
  background-color: #fff;
}
</style>
